import { createRootRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { AppErrorBoundary } from "../components/ErrorBoundary";
import { AuthProvider } from "../contexts/AuthContext";
import { GlobalModalProvider } from "../contexts/GlobalModalContext";
import { NavigationProvider } from "../contexts/NavigationContext";
import { ThemeProvider } from "../contexts/ThemeContext";
import { VoiceProvider } from "../contexts/VoiceContext";

function NotFoundRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate({ to: "/404" });
    }, [navigate]);

    return null;
}

function RootComponent() {
    return (
        <AppErrorBoundary>
            <Outlet />
        </AppErrorBoundary>
    );
}

export const Route = createRootRoute({
    head: () => ({
        meta: [
            {
                name: "description",
                content:
                    "Create magical interactive stories where your drawings shape the narrative. Perfect for families - AI-powered storytelling that brings imagination to life.",
            },
            { property: "og:title", content: "StoryDoodle - Interactive AI-Powered Storytelling for Kids" },
            {
                property: "og:description",
                content:
                    "Create magical interactive stories where your drawings shape the narrative. Perfect for families - AI-powered storytelling that brings imagination to life.",
            },
            { property: "og:image", content: "https://storydoodle.app/android-chrome-512x512.png" },
            { property: "og:url", content: "https://storydoodle.app/" },
            { property: "og:type", content: "website" },
            { name: "twitter:card", content: "summary_large_image" },
            { name: "twitter:title", content: "StoryDoodle - Interactive AI-Powered Storytelling for Kids" },
            {
                name: "twitter:description",
                content:
                    "Create magical interactive stories where your drawings shape the narrative. Perfect for families - AI-powered storytelling that brings imagination to life.",
            },
            { name: "twitter:image", content: "https://storydoodle.app/android-chrome-512x512.png" },
        ],
    }),
    notFoundComponent: NotFoundRedirect,
    component: () => (
        <ThemeProvider>
            <AuthProvider>
                <GlobalModalProvider>
                    <NavigationProvider>
                        <VoiceProvider>
                            <RootComponent />
                        </VoiceProvider>
                    </NavigationProvider>
                </GlobalModalProvider>
            </AuthProvider>
        </ThemeProvider>
    ),
});
